import * as React from "react";

export const Cell = ({children = null, day, isRestDay, date}: any) => <div className="ant-fullcalendar-date" title={date ? date.format('dddd D, MMMM') : day}>
  <div className="ant-fullcalendar-value" style={isRestDay ? {color: 'red'} : {}}>{day}</div>
  <div className="ant-fullcalendar-content">
    {children}
  </div>
</div>;

export default Cell;